import React from 'react';
import { Popover } from 'antd';
import { Help } from '@material-ui/icons';

import styles from './FormLabel.module.css';

export default function FormLabel({ popoverHelp, ...props }) {
	return (
		<label className={styles.label}>
			{props.children}
			{!!popoverHelp && (
				<Popover content={<div className={styles.popoverHelp}>{popoverHelp}</div>}>
					<Help className={styles.helpIcon}></Help>
				</Popover>
			)}
		</label>
	);
}